import { cn } from "@/utils/cn";
import { memo } from "react";

interface HomeIconProps {
  className?: string;
}

export const HomeIcon = memo(function HomeIcon({ className }: HomeIconProps) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path d="M17.5603 8.04474L10.0603 0.44484C9.77904 0.160004 9.39765 0 9 0C8.60235 0 8.22096 0.160004 7.93969 0.44484L0.439696 8.04474C0.299732 8.18552 0.188783 8.35309 0.1133 8.5377C0.0378174 8.72232 -0.00069249 8.9203 9.42513e-06 9.12013V18.24C9.42513e-06 18.4416 0.0790271 18.6349 0.219679 18.7774C0.360331 18.9199 0.551096 19 0.750009 19H6.75C6.94891 19 7.13968 18.9199 7.28033 18.7774C7.42098 18.6349 7.5 18.4416 7.5 18.24V12.9201H10.5V18.24C10.5 18.4416 10.579 18.6349 10.7197 18.7774C10.8603 18.9199 11.0511 19 11.25 19H17.25C17.4489 19 17.6397 18.9199 17.7803 18.7774C17.921 18.6349 18 18.4416 18 18.24V9.12013C18.0007 8.9203 17.9622 8.72232 17.8867 8.5377C17.8112 8.35309 17.7003 8.18552 17.5603 8.04474ZM16.5 17.48H12V12.1601C12 11.9585 11.921 11.7652 11.7803 11.6227C11.6397 11.4802 11.4489 11.4001 11.25 11.4001H6.75C6.55109 11.4001 6.36032 11.4802 6.21967 11.6227C6.07902 11.7652 6 11.9585 6 12.1601V17.48H1.50001V9.12013L9 1.52023L16.5 9.12013V17.48Z" />
    </svg>
  );
});
